import { ControlPosition, Map } from 'shared/map-exports';
import { ButtonGroup } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useTranslation } from 'react-i18next';
import { useMapGLController } from 'features/mapping/hooks/useMapGLController/useMapGLController';
import { MapControlButton, useButtonGroupStyles } from '../MapControlButton';
import {
  BaseMapboxGLController,
  BaseMapboxGLControllerProps,
  ThemeMode,
} from '../BaseMapboxGLController';

type NavigationControlProps = {
  position?: ControlPosition;
  forcedThemeMode?: ThemeMode;
};

const NavigationControlContent = (
  props: NavigationControlProps & { map?: Map },
): JSX.Element => {
  const { map } = props;
  const { t } = useTranslation();
  const { classes } = useButtonGroupStyles();

  const buttonSize = 'small';
  return (
    <ButtonGroup
      orientation="vertical"
      aria-label={t('map.accessibility.navControl')}
    >
      <MapControlButton
        ariaLabel={t('map.accessibility.zoomIn')}
        onClick={() => map?.zoomIn()}
        Icon={AddIcon}
        className={classes.groupTopButton}
        size={buttonSize}
      />
      <MapControlButton
        ariaLabel={t('map.accessibility.zoomOut')}
        onClick={() => map?.zoomOut()}
        Icon={RemoveIcon}
        className={classes.groupBottomButton}
        size={buttonSize}
      />
    </ButtonGroup>
  );
};

class MapboxGLNavigationController extends BaseMapboxGLController<
  NavigationControlProps & BaseMapboxGLControllerProps & { map?: Map }
> {
  content = (): JSX.Element => (
    <NavigationControlContent map={this.map} {...this.props} />
  );
}

export const NavigationControl = (props: NavigationControlProps): null => {
  useMapGLController(props, MapboxGLNavigationController);
  return null;
};
